import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "セクション登録")
], -1)
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = { class: "d-flex justify-content-center my-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-success mx-2 mb-2"
}, "登録", -1)

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useMessenger } from '@/plugins/message'
import { useNicotto, ConciergeSection, ConciergeCategory } from '@/plugins/nicotto'
import ConciergeHeaderQuestion from '@/components/parts/ConciergeHeaderQuestion.vue'
import SectionForm from '@/components/forms/ConciergeSection.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewView',
  props: {
    categoryId: null
  },
  setup(__props: any) {

const props = __props as {
  categoryId: string
}


const router = useRouter()
const nicotto = useNicotto()
const messenger = useMessenger()
const section = ref<ConciergeSection>(new ConciergeSection({ categoryId: props.categoryId }))
const category = ref<ConciergeCategory>()
nicotto.concierge.getCategory(props.categoryId)
  .then(data => {
    category.value = data
  })

const save = async() => {
  try {
    await nicotto.concierge.createSection(section.value)
    messenger.set('concierge.sections.saveSucceeded')
    router.push(`/concierge/categories/${props.categoryId}/sections`)
  } catch (err) {
    console.log(err)
    messenger.set('concierge.sections.saveFailed')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (category.value)
      ? (_openBlock(), _createBlock(ConciergeHeaderQuestion, {
          key: 0,
          category: category.value
        }, null, 8, ["category"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SectionForm, {
        modelValue: section.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((section).value = $event)),
        onSubmit: save,
        "category-id": __props.categoryId
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: `/concierge/categories/${props.categoryId}/sections`,
              class: "btn btn-secondary btn-lg mx-2 mb-2",
              role: "button"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_6
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "category-id"])
    ])
  ]))
}
}

})